const page = (themeId, surface, ink) => ({
    themeId: themeId,
    surface: surface,
    ink: ink,
});
export const MIDNIGHT = page('midnight', '#151c3f', '#e5e9ff');
export const PAPER = page('paper', '#fffaf0', '#3b2f1e');
export const SKY = page('sky', '#ffffff', '#1e293b');
//# sourceMappingURL=looks.js.map